import { useTranslation } from "react-i18next"
import { HighlightedText } from "@/modules/patients/patient-list/highlighted-text"
import { PatientSearchItem } from "@/modules/patients/patient-list/types/PatientSearchItem"

export type CoverageSlot = "compulsory" | "supplementary1" | "supplementary2" | "supplementary3"

interface PatientCoverageCellProps {
  patient: PatientSearchItem
  coverageSlot: CoverageSlot
  isHealthInsuranceCardNumberMissing: boolean
}

const MissingInsuranceCardNumber = () => {
  const { t } = useTranslation()

  return <p className="text-critical truncate text-xs">{t("patient.list.missingInsuranceCardNumber")}</p>
}

export const PatientCoverageCell = (props: PatientCoverageCellProps) => {
  const { patient, coverageSlot, isHealthInsuranceCardNumberMissing } = props
  const { highlights } = patient

  const organisationNameKey = `${coverageSlot}OrganisationName` as const
  const healthInsuranceCardNumberKey = `${coverageSlot}HealthInsuranceCardNumber` as const
  const policyNumberKey = `${coverageSlot}PolicyNumber` as const
  const insureeNumberKey = `${coverageSlot}InsureeNumber` as const

  const organisationName = patient[organisationNameKey]
  const healthInsuranceCardNumber = patient[healthInsuranceCardNumberKey]
  const insureeNumber = patient[insureeNumberKey]
  const isMissingCardNumber = isHealthInsuranceCardNumberMissing && !healthInsuranceCardNumber

  return (
    <div>
      <HighlightedText<PatientSearchItem>
        className="truncate"
        highlights={highlights}
        fields={[{ key: organisationNameKey, plain: organisationName }]}
      />
      {patient.country === "CH" && organisationName && isMissingCardNumber ? (
        <MissingInsuranceCardNumber />
      ) : (
        <HighlightedText<PatientSearchItem>
          className="text-on-surface-subdued truncate text-xs"
          highlights={highlights}
          fields={[
            patient.country === "CH"
              ? { key: healthInsuranceCardNumberKey, plain: healthInsuranceCardNumber }
              : { key: policyNumberKey, plain: patient[policyNumberKey] },
          ]}
        />
      )}
      {patient.country === "DE" && insureeNumber ? (
        <HighlightedText<PatientSearchItem>
          className="text-on-surface-subdued truncate text-xs"
          highlights={highlights}
          fields={[{ key: insureeNumberKey, plain: insureeNumber }]}
        />
      ) : null}
    </div>
  )
}
